import { useState } from "react";
import { X, Copy, Check } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function ModalMapaIncidente({ visible = false, onClose, incidente = null }) {
  const { t } = useTranslation();
  const [copiedKey, setCopiedKey] = useState("");

  if (!visible) return null;

  const lat = parseFloat(incidente?.latitud);
  const lng = parseFloat(incidente?.longitud);
  const hasValidCoords = Number.isFinite(lat) && Number.isFinite(lng);
  const embedUrl = hasValidCoords
    ? `https://maps.google.com/maps?q=${lat},${lng}&z=16&output=embed`
    : "";

  const handleCopyValue = async (value, key) => {
    try {
      const text = String(value ?? "").trim();
      if (!text || text === "-") {
        return;
      }
      await navigator.clipboard.writeText(text);
      setCopiedKey(key);
      window.clearTimeout(handleCopyValue._timer);
      handleCopyValue._timer = window.setTimeout(() => {
        setCopiedKey("");
      }, 1500);
    } catch (err) {
      console.log("handleCopyValue modal incidente err");
      console.log(err);
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 p-4">
      <div className="bg-white rounded-lg shadow-xl border border-gray-200 w-full max-w-5xl h-[85vh] flex flex-col">
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 flex-shrink-0">
          <h3 className="text-lg font-semibold text-gray-900">
            {t("label_mapa") || "Mapa"} - {t("label_detalle_incidente") || "Detalle incidente"}
          </h3>
          <button
            type="button"
            className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
            onClick={onClose}
            aria-label={t("label_cerrar") || "Cerrar"}
          >
            <X className="h-5 w-5 text-gray-600" />
          </button>
        </div>

        <div className="p-4 border-b border-gray-200 grid grid-cols-12 gap-4">
          <div className="col-span-12 md:col-span-6">
            <label className="block text-sm font-medium text-gray-700 mb-1">{t("column_estado_incidente")}</label>
            <div className="bg-gray-50 border border-gray-200 rounded-md px-3 py-2 text-sm text-gray-700">
              {incidente?.estadoIncidente || "-"}
            </div>
          </div>
          <div className="col-span-12 md:col-span-6">
            <label className="block text-sm font-medium text-gray-700 mb-1">{t("column_sub_estado_incidente")}</label>
            <div className="bg-gray-50 border border-gray-200 rounded-md px-3 py-2 text-sm text-gray-700">
              {incidente?.subEstadoIncidente || "-"}
            </div>
          </div>
          <div className="col-span-12 md:col-span-6">
            <label className="block text-sm font-medium text-gray-700 mb-1">{t("column_latitud")}</label>
            <div className="flex items-center gap-2">
              <input
                type="text"
                value={incidente?.latitud || "-"}
                readOnly
                className="w-full bg-gray-50 border border-gray-200 rounded-md px-3 py-2 text-sm text-gray-700"
              />
              <button
                type="button"
                className={`flex items-center gap-1 transition-colors ${copiedKey === "latitud" ? "text-green-600" : "text-gray-500 hover:text-gray-700"}`}
                onClick={() => handleCopyValue(incidente?.latitud, "latitud")}
                title={copiedKey === "latitud" ? "Copiado" : "Copiar"}
              >
                {copiedKey === "latitud" ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
                <span className="text-xs">{copiedKey === "latitud" ? "Copiado" : "Copiar"}</span>
              </button>
            </div>
          </div>
          <div className="col-span-12 md:col-span-6">
            <label className="block text-sm font-medium text-gray-700 mb-1">{t("column_longitud")}</label>
            <div className="flex items-center gap-2">
              <input
                type="text"
                value={incidente?.longitud || "-"}
                readOnly
                className="w-full bg-gray-50 border border-gray-200 rounded-md px-3 py-2 text-sm text-gray-700"
              />
              <button
                type="button"
                className={`flex items-center gap-1 transition-colors ${copiedKey === "longitud" ? "text-green-600" : "text-gray-500 hover:text-gray-700"}`}
                onClick={() => handleCopyValue(incidente?.longitud, "longitud")}
                title={copiedKey === "longitud" ? "Copiado" : "Copiar"}
              >
                {copiedKey === "longitud" ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
                <span className="text-xs">{copiedKey === "longitud" ? "Copiado" : "Copiar"}</span>
              </button>
            </div>
          </div>
        </div>

        <div className="flex-1 min-h-0 p-4">
          {hasValidCoords ? (
            <iframe
              title="mapa-incidente"
              src={embedUrl}
              className="w-full h-full rounded border border-gray-200"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          ) : (
            <div className="w-full h-full rounded border border-dashed border-gray-300 flex items-center justify-center text-sm text-gray-500">
              {t("label_sin_coordenadas") || "Sin coordenadas validas"}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
